export default "__VITE_ASSET__psOOrlKH__"